import * as React from 'react';
import Icons from '../icons';

export default class EmptySearchActivity extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="emptyScreen">
                <Icons name="EmptySearchActivity" className="" />    <br />
                <h2>No activities found</h2>
            </div>
        );
    }
}